import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';


export const IMPORTER_START_SUCCESS = createAction('IMPORTER_START_SUCCESS');
export const IMPORTER_START_FAIL = createAction('IMPORTER_START_FAIL');


export const IMPORTER_CANCEL_SUCCESS = createAction('IMPORTER_CANCEL_SUCCESS');
export const IMPORTER_CANCEL_FAIL = createAction('IMPORTER_CANCEL_FAIL');

export const importerStart = (siteId) => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(
                `${url}/import/start`,
                {
                    siteId,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            console.log(response, "26")
            if (response.data.success === true) {
                dispatch(IMPORTER_START_SUCCESS({ response: response.data }));
                // toastr.success('Success', 'fetching data...');
                return { success: true, data: response };
            } else {
                dispatch(IMPORTER_START_FAIL({ error: response.error }));
                toastr.error('Error', response);
                return { success: false, error: response.error };
            }
        } catch (error) {
            const errorMessage =
                error.response?.data?.message ||
                error.message ||
                'Failed to start importer ';
            dispatch(IMPORTER_START_FAIL({ error: errorMessage }));
            toastr.error('Error', errorMessage);
            return { success: false, error: errorMessage };
        }
    };
};


export const importerCancel = () => {
    return async (dispatch) => {
        try {
            const response = await Axios.post(
                `${url}/import/cancel`,
                {
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            console.log(response, "26")
            if (response.data.success === true) {
                dispatch(IMPORTER_CANCEL_SUCCESS({ response: response.data }));
                // toastr.success('Success', 'fetching data...');
                return { success: true, message: response };
            } else {
                dispatch(IMPORTER_CANCEL_FAIL({ error: response.error }));
                toastr.error('Error', response);
                return { success: false, message: response.error };
            }
        } catch (error) {
            const errorMessage =
                error.response?.data?.message ||
                error.message ||
                'Failed to start importer ';
            dispatch(IMPORTER_START_FAIL({ error: errorMessage }));
            toastr.error('Error', errorMessage);
            return { success: false, error: errorMessage };
        }
    };
};